import { ca } from '@cian/analytics';

import { IOfferSchema } from 'shared/types/api-models/offer-card/v1/get-offer-data';

import { TPageExtra } from '../../../types';
import { IPromoInfo } from '../../../types/newbuildingPromos';
import { getProducts } from '../../../utils/tracking/get_products';
import { ISoprProducts } from '../../../utils/tracking/types';

interface ITrackClickPromoBlock {
  promo: IPromoInfo;
  offer: IOfferSchema;
  mainSidebarPromo?: boolean;
}

export function trackClickPromoBlock({ promo, offer, mainSidebarPromo }: ITrackClickPromoBlock) {
  const extra: Partial<TPageExtra> = {
    promoCianMortgage: promo.uniquePromoId,
    promoId: promo.promoId,
    is_price_with_discount: promo.promoType === 'discount',
    placeType: mainSidebarPromo ? 'side_bar' : 'main_price',
  };

  const products: ISoprProducts = getProducts({ agent: null, offer, kpId: null, extra });

  ca('eventSite', {
    name: 'oldevent',
    category: 'Promo',
    action: 'click_block',
    label: promo.promoType,
    products: [products],
  });
}
